import { gql } from 'apollo-angular'

export const PERSON_BASIC_FIELDS = gql`
  fragment PersonBasicFields on Author {
    id
    name
    first_name
    last_name
    middle_name
    post_title
    pre_title
    initials
  }
`

export const PERSON_DETAIL_FIELDS = gql`
  ${PERSON_BASIC_FIELDS}
  fragment PersonDetailFields on Author {
    ...PersonBasicFields
    email
    company_name
    department
    function
    about
    social_link
    firm_page
    media {
      filename
      url
    }
  }
`
